import { AfterViewInit, Component, ElementRef, forwardRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

// Basit contenteditable tabanlı HTML editörü (harici bağımlılık yok, CSP dostu).
// [(ngModel)] ile kullanılır; değer HTML olarak tutulur. Yapıştırmada biçim temizlenir.
@Component({
  selector: 'app-rich-editor',
  standalone: true,
  template: `
    <div class="rich-editor" [class.disabled]="disabled">
      <div class="rich-toolbar">
        <button type="button" title="Kalın" (mousedown)="exec($event, 'bold')"><i class="fa-solid fa-bold"></i></button>
        <button type="button" title="İtalik" (mousedown)="exec($event, 'italic')"><i class="fa-solid fa-italic"></i></button>
        <span class="sep"></span>
        <button type="button" title="Madde listesi" (mousedown)="exec($event, 'insertUnorderedList')"><i class="fa-solid fa-list-ul"></i></button>
        <button type="button" title="Numaralı liste" (mousedown)="exec($event, 'insertOrderedList')"><i class="fa-solid fa-list-ol"></i></button>
        <span class="sep"></span>
        <button type="button" title="Biçimi temizle" (mousedown)="exec($event, 'removeFormat')"><i class="fa-solid fa-eraser"></i></button>
      </div>
      <div #ed class="rich-area" contenteditable="true"
           (input)="onInput()" (blur)="onTouched()" (paste)="onPaste($event)"></div>
    </div>
  `,
  styles: [`
    .rich-editor { border: 1px solid #ced4da; border-radius: 8px; overflow: hidden; background: #fff; }
    .rich-editor:focus-within { border-color: var(--brand-accent); box-shadow: 0 0 0 .2rem rgba(127,46,141,.15); }
    .rich-editor.disabled { opacity: .6; pointer-events: none; }
    .rich-toolbar { display: flex; align-items: center; gap: 2px; padding: 6px 8px; background: #f8f9fa; border-bottom: 1px solid #e9ecef; }
    .rich-toolbar button { border: 0; background: none; width: 30px; height: 28px; border-radius: 6px; color: #495057; cursor: pointer; font-size: 13px; }
    .rich-toolbar button:hover { background: rgba(127,46,141,.1); color: var(--brand-accent); }
    .rich-toolbar .sep { width: 1px; height: 18px; background: #dee2e6; margin: 0 4px; }
    .rich-area { min-height: 130px; max-height: 340px; overflow-y: auto; padding: 12px 14px; font-size: 14px; line-height: 1.5; outline: none; }
    .rich-area ul, .rich-area ol { margin: 6px 0; padding-left: 22px; }
    .rich-area p { margin: 0 0 8px; }
  `],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RichEditorComponent), multi: true }]
})
export class RichEditorComponent implements ControlValueAccessor, AfterViewInit {
  @ViewChild('ed') ed!: ElementRef<HTMLDivElement>;
  disabled = false;

  private pending = '';
  private ready = false;
  onChange: (v: string) => void = () => {};
  onTouched: () => void = () => {};

  ngAfterViewInit() {
    this.ready = true;
    if (this.pending) this.ed.nativeElement.innerHTML = this.pending;
  }

  writeValue(v: string): void {
    this.pending = v || '';
    if (this.ready && this.ed && this.ed.nativeElement.innerHTML !== this.pending) {
      this.ed.nativeElement.innerHTML = this.pending;
    }
  }
  registerOnChange(fn: (v: string) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
  setDisabledState(d: boolean): void { this.disabled = d; }

  onInput() {
    const html = this.ed.nativeElement.innerHTML;
    this.onChange(html === '<br>' ? '' : html);
  }

  exec(ev: MouseEvent, command: string) {
    ev.preventDefault();               // seçim kaybolmasın
    document.execCommand(command, false);
    this.ed.nativeElement.focus();
    this.onInput();
  }

  // Yapıştırırken biçimlendirmeyi at, düz metin ekle.
  onPaste(ev: ClipboardEvent) {
    ev.preventDefault();
    const text = ev.clipboardData?.getData('text/plain') || '';
    document.execCommand('insertText', false, text);
  }
}
